/**
 * Goods Receipting → Food Safety Deliveries, opening the recent-deliveries
 * picker on that receipt (`?po=…&supplierId=…`).
 */

import {
  FOOD_SAFETY_PURCHASE_ORDER_NUMBER_MAX_LENGTH,
  FOOD_SAFETY_SECTION,
} from 'src/constants/foodSafety'

export const FOOD_SAFETY_DELIVERY_CHECK_LABEL =
  'Product temperatures (optional)'

export const FOOD_SAFETY_DELIVERY_CHECK_HINT =
  'Open this delivery to record sampled product temperatures. A supplier delivery record does not mean every product was temperature-checked.'

const clean = value => String(value ?? '').trim()

export function buildFoodSafetyDeliveryCheckPath(
  venueId,
  { purchaseOrderNumber, supplierId } = {},
) {
  const base = `/v/${venueId}/food-safety/section/${FOOD_SAFETY_SECTION.DELIVERIES}`
  const po = clean(purchaseOrderNumber)
  if (!po) return base
  const params = new URLSearchParams({ po })
  const supplier = clean(supplierId)
  if (supplier) params.set('supplierId', supplier)
  return `${base}?${params.toString()}`
}

/** `{ purchaseOrderNumber, supplierId }` from the Deliveries URL, or null. */
export function readFoodSafetyDeliveryCheckQuery(search) {
  const params = new URLSearchParams(search || '')
  const po = clean(params.get('po'))
  if (!po || po.length > FOOD_SAFETY_PURCHASE_ORDER_NUMBER_MAX_LENGTH) {
    return null
  }
  const supplierId = clean(params.get('supplierId'))
  return { purchaseOrderNumber: po, supplierId: supplierId || null }
}

/** Receipting rows/records → link args (supplier may be an id or object). */
export function foodSafetyDeliveryCheckTarget(record) {
  const supplier = record?.supplier
  return {
    purchaseOrderNumber: record?.purchaseOrderNumber,
    supplierId:
      supplier && typeof supplier === 'object' ? supplier._id : supplier,
  }
}
